import { useEffect } from "react";
import { clientToSvgPoint } from "utils/math/clientToSvgPoint";
import { normalizeWheelDelta } from "utils/math/normalizeWheelDelta";
import { calculateZoomedViewBox } from "utils/math/calculateZoomedViewBox";
import { UseSvgPinchZoom } from "./types";

export const useSvgPinchZoom: UseSvgPinchZoom = ({
  svgRef,
  viewBoxRef,
  baseViewBox,
  isDisabled,
  minZoomWidth,
  wheelConfig,
  onZoom,
}) => {
  useEffect(() => {
    if (isDisabled) return;

    const svg = svgRef.current;
    if (!svg) return;

    const handleWheel = (e: WheelEvent) => {
      // Detect if it's a trackpad pinch (Ctrl/Meta key pressed)
      // const isPinchGesture = e.ctrlKey || e.metaKey;
      // if (!isPinchGesture) return;

      e.preventDefault();

      const rect = svg.getBoundingClientRect();
      const currentViewBox = viewBoxRef.current;

      const point = clientToSvgPoint({
        clientX: e.clientX,
        clientY: e.clientY,
        rect,
        viewBox: currentViewBox,
      });

      const delta = normalizeWheelDelta({
        e,
        pixelMultiplier: wheelConfig.pixelMultiplier,
        lineMultiplier: wheelConfig.lineMultiplier,
        maxDelta: wheelConfig.maxDelta,
      });
      const factor = Math.exp(delta * wheelConfig.sensitivity);

      const newVb = calculateZoomedViewBox({
        zoomCenterX: point.x,
        zoomCenterY: point.y,
        factor,
        currentViewBox,
        baseViewBox,
        minZoomWidth,
      });

      onZoom(newVb);
    };

    svg.addEventListener("wheel", handleWheel, { passive: false });

    return () => svg.removeEventListener("wheel", handleWheel);
  }, [
    svgRef,
    viewBoxRef,
    baseViewBox,
    isDisabled,
    minZoomWidth,
    wheelConfig,
    onZoom,
  ]);
};
